import { Injectable } from '@angular/core';
import { WindowRefService } from './window-ref.service';

export interface NavActive {
  isActive(currentUrl, navUrl): boolean;
  activeNav(navLinks: Array<Object>): Array<Object>;
}

@Injectable()
export class NavActiveService implements NavActive {

  constructor(public _window: WindowRefService) { }

  isActive(currentUrl, navUrl): boolean {
    return !!currentUrl.toLowerCase()
      .match(new RegExp(`${navUrl}$`, 'i'));
  }

  activeNav(navLinks: Array<Object>): Array<Object> {
    const location = this._window.nativeWindow['location'];
    const currentUrl = [location.protocol, '//', location.host, location.pathname].join('');

    navLinks.forEach(primaryNav => {
      primaryNav['isActive'] = this.isActive(currentUrl, primaryNav['url']);

      if (primaryNav['children'] && primaryNav['children'].length > 0) {
        primaryNav['children'].every(secondaryNav => {

          if (this.isActive(currentUrl, secondaryNav['url'])) {
            secondaryNav['isActive'] = true;
            primaryNav['isActive'] = true;

            return false;
          }

          return true;
        });
      }
    });

    return navLinks;
  }

}
